import React from "react";

type DisplayCardProps = {
  children?: React.ReactNode;
  onClick?: () => void;
};
const DisplayCard = ({ children, onClick }: DisplayCardProps) => {
  return (
    <li
      className={`group test overflow-hidden rounded-xl border border-slate-200 hover:border-slate-300 hover:bg-slate-50 ${
        onClick && "cursor-pointer"
      }`}
      onClick={onClick}
    >
      {children}
    </li>
  );
};

export default DisplayCard;
